import * as Yup from "yup";

export const EmailSchema = Yup.object().shape({
  sender: Yup.string().required("Sender's name is required"),
  senderemail: Yup.string().required("Please provide the email address of the sender"),
  subject: Yup.string().required("Please enter the minimum stock"),
  message: Yup.string().required("Email body is required"),
  destination: Yup.string().required("Email recipient is required")
});